import { ReactNode } from 'react';
import { AppState, Auth0Provider } from '@auth0/auth0-react';
import { useSafeNavigation } from '../../../hooks/useSafeNavigation';
import { FullSizeLoader } from '../../../components/FullSizeLoader';

const env = import.meta.env;
const domain = env.VITE_AUTH0_DOMAIN;
const clientId = env.VITE_AUTH0_CLIENT_ID;
const audience = env.VITE_AUTH0_AUDIENCE;

type ProviderProps = {
  children: ReactNode;
};

export const Auth0ProviderWithNavigate = ({ children }: ProviderProps) => {
  const { safeNavigate } = useSafeNavigation();

  const onRedirectCallback = (appState?: AppState) => {
    safeNavigate(appState?.returnTo ?? window.location.pathname);
  };

  if (!(domain && clientId && audience)) {
    return <FullSizeLoader />;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: audience,
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};
